import { assignCommonProperties } from '../../util/data/assign-common-properties.js'
import { BoReference } from '../../bos/bo-reference.js'
import { Block } from '../block.js'

export class FormElement {
	getBlocks?(): Block[] {
		return []
	}
}

export class FormControlElement extends FormElement {
	variable?: string
	boRef?: BoReference
	bindingPropertyName?: string
	block!: Block
	parentBlock?: Block
	mandatory?: boolean | 'inherit' | 'custom' = 'inherit'
	maxLength?: number = 0

	constructor(init: FormControlElement) {
		super()
		assignCommonProperties(this, init)
	}

	getBlocks?(): Block[] {
		return [this.block]
	}
}

export class FormOtherBlocksElement extends FormElement {
	blocks: Block[] = []

	constructor(init: FormOtherBlocksElement) {
		super()
		assignCommonProperties(this, init)
	}

	getBlocks?(): Block[] {
		return this.blocks
	}
}
